module.exports = __webpack_public_path__ + "img/PtownFlags_01.56485ba5.png";